<template>
  <div class="row">
    <div class="col-md-12">
      <!-- DATA TABLE -->
      <DataTable
        ref="datatable"
        :settings="datatable.settings"
        :dataColumns="datatable.columns"
        :dataFeed="datatable.dataFeed"
        :dataHandle="datatable.handle"
        :dataTableHeight="datatable.height"
        :datas="datas"
        :defaultSortBy="datatable.sortBy"
        :defaultOrderBy="datatable.orderBy"
        :customSelectItem="selectItem"
        :customUnselectItem="unselectItem"
        :customAfterDeleteEvent="unselectItem"
        :allowView="allowView"
        :allowEdit="allowEdit"
        :allowDelete="allowDelete"
        :hasContextMenu="hasContextMenu"
        :customRowStyle="customRowStyle"
      >
        <template slot="menuButtons" slot-scope="props">
          <template v-if="props.item && props.item.data">
            <li @click="$refs.datatable.viewItem($event, props.item.data)" v-if="allowView(props.item.data)">View</li>
            <li @click="$refs.datatable.editItem($event, props.item.data)" v-if="allowEdit(props.item.data)">Edit</li>
            <li @click="$refs.datatable.confirmDelete($event, props.item.data)" v-if="allowDelete(props.item.data)">Delete</li>
          </template>
        </template>
      </DataTable>
      <!-- END DATA TABLE -->
      <VendorContact :selectedVendor="selectedVendor" v-if="selectedVendor"/>

      <ImportModule 
          ref="importModule"
          @reload="reload"
          :uploadURL="$root.WebService.vendor + '/import/upload'" 
          :confirmURL="$root.WebService.vendor + '/import/confirm'"/>

    </div>
  </div>
</template>
<script>

import ImportModule from 'src/components/ImportModule'
import exportData from 'src/global/exportData.js'
import importData from 'src/global/importData.js'

import VendorContact from "./VendorContact"

export default {
  components: {
    VendorContact,
    ImportModule
  },
  data() {
    return {
      pageSettings: {
        pageTitle: 'Vendor',
        sectionName: 'vendor',
        sectionIcon: 'fas fa-truck',
        type: this.pageType,
        useDefault: false,
        webService: this.$root.WebService.vendor,
        navigation: [
          { name: 'Vendor', route: 'vendor.index' }
        ],
        buttons: [],
        subSidebar: {}
      },
      datatable: {
        settings: {
          sectionName: 'vendor',
          webService: this.$root.WebService.vendor,
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'name', title: 'Vendor Name', type: 'input', width: '35%', value: null },
          { key: 'code', title: 'Vendor Code', type: 'input', width: '5%', value: null },
          { key: 'short_name', title: 'Short Name', type: 'input', width: '5%', value: null },
          { key: 'product_range', title: 'Product Range', type: 'input', width: '40%', value: null },
          //{ key: 'vendor_tel', title: 'Tel No.', type: 'input', width: '10%', value: null },
          //vendor_fax: { title: 'Fax No.', type: 'input', width: '10%', value: null },
          {            key: 'enabled', title: 'Status', type: 'select', width: '5%', value: null, datafilter: this.$options.filters.booleanEnabledText, selectOptions:
            {
              key: 'enabled', valueKey: 'value', displayKey: 'title', datas: [{ value: 0, title: 'Disabled' }, { value: 1, title: 'Enabled' }]
            }
          },
          { key: 'created_at', title: 'Created At', type: 'datepicker', width: '10%', datafilter: this.$options.filters.dateFormat, value: { from: null, to: null } },
        ],
        sortBy: null,
        orderBy: 'desc',
        width: '100%',
        height: '70vh',
      },
      datas: [],
      filteredDatas: [],
      selectedVendor: null,
      selectedItemContact: null,
      exportFunction: {
        url: this.$root.WebService.vendor + '/export',
        fileName: 'ExportVendor'
      },
    }
  },
  mounted() {

    if( this.hasPermission('import vendor') ) this.pageSettings.buttons.push({ name: 'Import', icon: 'fas fa-file-upload', action: this.importData })
    if( this.hasPermission('export vendor') ) this.pageSettings.buttons.push({ name: 'Export', icon: 'fas fa-file-download', action: this.exportData })
    if( this.hasPermission('create vendor') ) this.pageSettings.buttons.push({ name: 'Add New Vendor', icon: 'fas fa-plus', action: this.addItem })

    this.$emit('setPageHeader', this.pageSettings)
    this.datatable.handle = (res) => this.datas = res.data.data
    this.datatable.dataFeed = {
      method: 'get',
      url: this.pageSettings.webService
    }
  },
  methods: {
    selectItem(item, key) {
      if( !this.hasPermission('read vendor_contact') ) return
      this.$refs.datatable.filteredDatas = [item]
      this.$refs.datatable.page = 1
      this.$refs.datatable.remain = 1
      this.$refs.datatable.$refs.virtualList.forceRender()

      this.selectedVendor = item
    },
    unselectItem(item, key) {
      this.selectedVendor = null
      
      this.$refs.datatable.doFilter()
      this.$refs.datatable.page = this.$refs.datatable.previousPage
      this.$refs.datatable.remain = null
      this.$refs.datatable.$refs.virtualList.forceRender()
    },
    showModalVendorContact(item) {
      this.selectedVendor = item
    },
    addItem() {
      this.$router.push({ name: this.pageSettings.sectionName + '.create' })
    },
    exportData,
    importData,
    allowView(item) {
      return this.hasPermission('read vendor')
    },
    allowEdit(item) {
      return this.hasPermission('update vendor')
    },
    allowDelete(item) {
      return this.hasPermission('delete vendor') && false
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    },
    customRowStyle(item) {
      if( !item.enabled )
        return {'background-color': '#ff6b6b'};
    },
    reload() {
      this.$refs.datatable.reload()
      this.selectedVendor = null
    }
  }
}
</script>